<template>
  <el-container class="camadd">
    <el-header class="box add bb">
       <el-breadcrumb separator-class="el-icon-arrow-right">
       <el-breadcrumb-item>监管管理</el-breadcrumb-item>
       <el-breadcrumb-item>监管分类</el-breadcrumb-item>
        <el-breadcrumb-item v-if="form.company_type_id">编辑监管分类</el-breadcrumb-item>
         <el-breadcrumb-item v-else>新增监管分类</el-breadcrumb-item>
    </el-breadcrumb>
      <div>
        <el-button class="back_btn"
                   size="medium"
                   plain
                   @click="$router.back()">返回</el-button>
      </div>
    </el-header>
    <el-main class="pt0">
      <el-form  ref="form" :model="form" class="demo-ruleForm">
                <el-row class="box mt20  f14">
       <el-col :span="11" class="" >
        <el-form-item  size="medium" class="w" label-width="28%" label="监管分类名称：" prop='company_type_name' :rules="[{required: true,message: '请输入监管分类名称', trigger: 'blur' },{ pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }]">
            <el-input v-model="form.company_type_name"
                    size="medium"
                    clearable></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="22" class="tl"  :offset="1">
        <el-button class size="medium" type="primary" @click="onSubmit('form')">提交</el-button>
        </el-col>
                </el-row>
      
      </el-form>

    
    </el-main>
  </el-container>
</template>
<script>
import axios from "../../../util/api";
import {session} from '../../../util/util'
export default {
  data () {
    return {
      labelPosition: "right",
      dialogImageUrl: '',
      form:{
          company_type_id:'',//监管分类ID 更新操作必传,新增不需要传
          company_type_name:''
      }
    };
  },
  filters: {},
  created () {
       this.form.company_type_id =session.get('params').id?String(session.get('params').id):'';
        if(this.form.company_type_id){ this.getDate()}//编辑获取回显信息
   },
  methods: {
      getDate(){
          axios.get("/pc/company-type/single",{company_type_id:String(this.form.company_type_id)}).then(v => {
           this.form.company_type_name=v.data.company_type.company_type_name
          });
      },
        onSubmit (form) {
          
      this.$refs[form].validate((valid) => {
        if (valid) {
            //  this.form.company_type_id=String(this.form.company_type_id)
          axios.get("/pc/company-type/exist", this.form).then(v => {//验证查询监管分类是否存在
           if(this.form.company_type_id){
                
               axios.put("/pc/company-type/update",this.form).then(response => {
              this.$router.back();
            })}else{
              axios.post("/pc/company-type/save",this.form).then(response => {
              this.$router.back();
            })
           }
           
          });
        }else{
           this.$message.error('请检查表单必填项');
            return false
        }
      })
    },
    exist (sensor_number) {
      if (sensor_number != null && sensor_number.length > 0) {
        axios.get("/api/sensor/exist", { sensor_number: sensor_number }).then(v => {
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.camadd {
  overflow-x: hidden;
  .add {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .el-image {
    width: 160px;
    height: 160px;
    margin-right: 10px;
  }
  .back_btn {
    background: rgba(247, 248, 249, 1);
    border: 1px solid rgba(217, 222, 225, 1);
  }
  .patroladd-title {
    height: 34px;
    line-height: 34px;
    border-left: 2px solid #788287;
  }
  .form-container {
    margin-top: 20px;
    padding-right: 35px;
    /deep/ .el-form-item__content {
      width: 50%;
    }
  }
  /deep/ .el-radio__label {
    display: none !important;
  }
  /deep/ .el-dialog__body {
    padding-top: 5px;
    padding-bottom: 10px;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #ffffff;
    border-color: #e4e7ed;
    color: #606266;
    cursor: not-allowed;
  }
  /deep/ .el-dialog {
    width: 60% !important;
  }
  /deep/ .disabled .el-upload--picture-card {
    display: none !important;
  }
  /* .el-form-item--medium .el-form-item__content{width: 80%} */
}
</style>
